import React from 'react';
import { Spinner as Spin, SpinnerSizes } from 'flowbite-react';

import { SpinnerTheme } from '../../styles/themes/spinner';
import { VisuallyHidden } from '../visually-hidden';

export type SpinnerProps = {
    size?: keyof SpinnerSizes;
    color?: string;
    alignment?: 'left' | 'center' | 'right';
    className?: string;
    id?: string;
    testId?: string;
    label?: string;
    /** false names the spinner without a live region, for spinners a page-level status already covers. */
    announce?: boolean;
};

export const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>((props, ref) => {
    const { size = 'md', color = 'secondary', alignment, className, id, testId, label, announce = true } = props;
    const silentLabel = !!label && !announce;
    return (
        // text class on wrapper is required to assign a color to the 'background' circle
        <div
            ref={ref}
            className={`${className} text-system-surface-container`}
            role={silentLabel ? 'img' : undefined}
            aria-label={silentLabel ? label : undefined}
        >
            {/* flowbite puts an empty role="status" on the graphic, so it is hidden and the label is the live region */}
            <Spin
                theme={SpinnerTheme}
                color={color}
                size={size}
                className={`text-${alignment}`}
                id={id}
                data-testid={testId}
                aria-hidden="true"
            />
            {label && announce && <VisuallyHidden role="status">{label}</VisuallyHidden>}
        </div>
    );
});

Spinner.displayName = 'Spinner';
